import type { RouteRecordRaw } from 'vue-router'
import { DealsRoutes } from '@/routes/user/deals/types'
import { AppModule } from '@/config/types'
import PassThrough from '@/components/layout/PassThrough.vue'

export const getDealsPipelineRoutes = (): RouteRecordRaw[] => [
  {
    name: DealsRoutes.base,
    path: '',
    redirect: { name: DealsRoutes.pipelineBase },
    meta: {
      modules: [AppModule.ComingSoon],
      resolvers: [{ service: 'DealPipelineResolverService' }, { service: 'FetchAllAccountsResolver' }],
      resolverComponent: () => import('@/components/resolvers/DealsPipelineResolver.vue'),
    },
    children: [
      {
        name: DealsRoutes.pipelineBase,
        path: '',
        meta: {
          resolvers: [{ service: 'DealsRedirectToFirstPipelineResolverService' }],
          resolverComponent: () => import('@/components/resolvers/DealsPipelineResolver.vue'),
        },
        component: PassThrough,
      },
      {
        name: DealsRoutes.overview,
        path: 'overview',
        meta: {
          resolvers: [{ service: 'DealsRedirectToFirstPipelineResolverService' }],
          resolverComponent: () => import('@/components/resolvers/DealsPipelineResolver.vue'),
        },
        component: () => import('@/components/views/deals/DealsEmptyOverview.vue'),
      },
      {
        name: DealsRoutes.pipeline,
        path: 'pipeline/:pipelineId',
        props: true,
        meta: {
          resolvers: [
            {
              service: 'DealPipelineExistsResolverService',
            },
          ],
          resolverComponent: () => import('@/components/resolvers/DealsPipelineResolver.vue'),
        },
        component: () => import('@/components/views/deals/Pipeline.vue'),
      },
    ],
  },
]
